import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.css"; // Modernes Styling

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); 
  
    const response = await fetch("https://poke-meta.com/api/login",{
      method: "POST",
      headers: {"Content-Type": "application/json" },
      body: JSON.stringify({ username, password }), 
    });
  
    const data = await response.json();
    console.log("Login Response:", data); // Debugging
  
    if (data.status === "success") {
      alert("Login erfolgreich!");

      navigate("/privatadminadmin/dashboard");
    } else {

      setError("Falsche Anmeldedaten"); // Fehlermeldung anzeigen
    }
  };
  

  return (
    <div className="admin-container">
      <h1 className="admin-title">Admin Login</h1>
      <form className="admin-form" onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Benutzername"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="admin-input"
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="admin-input"
        />
        <button type="submit" className="admin-button">Login</button>
        {error && <p className="admin-error">{error}</p>}
      </form>
    </div>
  );
};

export default AdminLogin;
